import React from 'react';

import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PrimaryToggleProps {
  isPrimary: boolean;
  showToggle: boolean;
  onToggle: () => void;
}

/**
 * A reusable star toggle component for marking items as primary.
 *
 * @param props - The component props.
 * @returns The PrimaryToggle component.
 */
export const PrimaryToggle: React.FC<PrimaryToggleProps> = ({ isPrimary, showToggle, onToggle }) => {
  if (!showToggle) {
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={isPrimary ? faStar : faStarRegular}
      onClick={onToggle}
      role="button"
      tabIndex={0}
      aria-pressed={isPrimary}
      aria-label={isPrimary ? 'Remove as primary' : 'Set as primary'}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
    />
  );
};
